import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageTitleStyles,
  OverlayStyles,
  SubtitleStyles,
  MainImageStyles,
} from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'WelcomeScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="dark-solid">
      <IonContent>
        <OverlayStyles />
        <MainImageStyles>
          <img
            src={`${S3_BUCKET_URL}/own-ai-compatibility/welcome/background.png`}
            alt="Young couple"
          />
        </MainImageStyles>
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Compatibility Test
            <SubtitleStyles variant={'body-medium'}>
              Discover your perfect AI girlfriend. Just answer
              <br />a few quick questions.
            </SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize={'large'}
            buttonRadius="md"
            onContinue={handleNextStep}
            buttonText={'Start'}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
